import React, { useState } from 'react';
import PropType from 'prop-types';

export const TabItem = (props) => {
	return props.children;
};
TabItem.propTypes = {
	children: PropType.oneOfType([PropType.string, PropType.array]),
};

export const Tabs = ({ children, label }) => {
	const data = children || [];
	const [visibleTab, setVisibleTab] = useState(0);
	const listTitles = React.Children.map(data, (item, index) => {
		const { displayText, id } = item.props;
		return (
			<button
				aria-selected={visibleTab === index ? 'true' : 'false'}
				className="tabs__button"
				id={`tab__button-${id}-${index}`}
				key={`tab__button-${id}-${index}`}
				onClick={() => setVisibleTab(index)}
				role="tab"
				tabIndex={visibleTab === index ? '-1' : null}>
				{displayText}
			</button>
		);
	});

	const listContent = React.Children.map(data, (item, index) => {
		const { id } = item.props;
		return (
			<div
				hidden={visibleTab === index ? null : 'hidden'}
				id={`${id}-${index}`}
				key={`${id}-${index}`}
				role="tabpanel"
				tabIndex="0">
				{item}
			</div>
		);
	});
	return (
		<div className="tabs" aria-label={`${label}`}>
			<div role="tablist" className="tabs__button-group">
				{listTitles}
			</div>
			<div className="tabs__panel-group">{listContent}</div>
		</div>
	);
};

Tabs.propTypes = {
	children: PropType.node,
	data: PropType.object,
	label: PropType.string,
};
